import React from 'react';

import S from './Screen.module.css';

const ScreenIcons = () => (
  <div className={S.container}>
    <div className={S.icon} data-index="1" data-size="big">
      <div className={S.iconPhone}></div>
      <div className={S.title}>No SIM</div>
    </div>
    <div className={S.icon} data-index="2" data-size="big">
      <div className={S.iconMessaging}>;-)</div>
      <div className={S.title}>Messaging</div>
    </div>
    <div className={S.icon} data-index="3" data-size="big">
      <div className={S.iconEmail}></div>
      <div className={S.title}>Email</div>
    </div>
    <div className={S.icon} data-index="4" data-size="small">
      <div className={S.iconCalendar}></div>
    </div>
    <div className={S.icon} data-index="5" data-size="small">
      <div className={S.iconCalculator}></div>
    </div>
    <div className={S.icon} data-index="6" data-size="small">
      <div className={S.iconHighlights}></div>
    </div>
    <div className={S.icon} data-index="7" data-size="small"></div>
    <div className={S.icon} data-index="8" data-size="big">
      <div className={S.iconCamera}>
        <div />
      </div>
      <div className={S.title}>Camera</div>
    </div>
    <div className={S.icon} data-index="9" data-size="small" />
    <div className={S.go2apps} />
  </div>
);

const Screen = ({ isOn, children, onClick }) => (
  <div className={S.root} onClick={onClick}>
    {children}
    {isOn && <ScreenIcons />}
  </div>
);

export default Screen;
